import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const OpenLink = withDefaultIconProps(
  {
    height: 16,
    width: 16,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 16 16" fill="none">
      <Path
        d="M9 7l5-5m0 3.333V2h-3.333M14 9.333v3.334A1.334 1.334 0 0112.667 14H3.333A1.334 1.334 0 012 12.667V3.333A1.333 1.333 0 013.333 2h3.334"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  ),
);
